log = require 'loglevel'
Tween = require 'tween'
BaseButton = require 'BaseButton'
eventManager = require 'eventManager'
currencyManager = require 'currencyManager'
imageManager = require 'imageManager'
soundManager = require 'soundManager'
trackingManager = require 'trackingManager'
gameModel = require 'gameModel'


class BottomBarView extends PIXI.Container

  w: 360
  h: 45
  bgAlpha: 0.7
  winAmount: 0
  textYOffset: 18
  textGap: 10
  showTickets: false
  buttonYOffset: 0
  buttonXOffset: 46
  infoGroupWidth: 100
  infoContainerXOffset: 160
  interactive: true
  counterTween: null

  labelStyle:
    fontSize: 9
    fontWeight: 400
    fill:  '#FFFFFF'
    wordWrap:  false
    lineHeight:  15
    padding: 2
    letterSpacing: 2

  valueStyle:
    fontSize: 12
    fontWeight: 400
    wordWrap:  false
    lineHeight:  15
    padding: 2


  # -------------------------------------------

  constructor: (viewportWidth, viewportHeight) ->

    super()

    @labelStyle.fontFamily = gameModel.getFont()
    @valueStyle.fontFamily = gameModel.getFont()
    @valueStyle.fill = gameModel.primaryColor

    @_setDimension(viewportWidth, viewportHeight)

    @showTickets = gameModel.isBasketMode()
    @showHomeButton = gameModel.getHomeUrl()?
    @showHelpButton = gameModel.getHelpUrl()?

    @addBg()
    @addInfoContainer()
    @addButtonContainer()

    # add appropriate buttons
    if @showHomeButton
      @addHomeButton(0)
      @addSettingsButton(45)
      @addHelpButton(90) if @showHelpButton
    else
      @addSettingsButton(0)
      @addHelpButton(45) if @showHelpButton


    # listen when to enable/disable
    if @showHelpButton
      eventManager.listenTo 'disable-navigation', =>
        @helpButton.disable()
      eventManager.listenTo 'enable-navigation', =>
        @helpButton.enable()
      eventManager.listenTo 'showing-overlay', =>
        @helpButton.disable()
      eventManager.listenTo 'hiding-overlay', =>
        @helpButton.enable()

    ticketX = 0
    # balance
    if not gameModel.getDontShowBalance()
      @addBalance(gameModel.getBalance(),@infoGroupWidth)
      eventManager.listenTo 'balance', (amount) =>
        @updateBalance amount
    else
      ticketX = @infoGroupWidth

    # prebought tickets
    if @showTickets
      eventManager.listenTo 'tickets', (amount) =>
        @updateTicketCount amount
      label =  __t.str('Tickets left').toUpperCase()
      @addTickets(label, ticketX, gameModel.getRoundsLeft())
      return @

    # buy from wallet
    if not gameModel.getDontShowStake()
      label =  __t.str('Stake').toUpperCase()
      amount = gameModel.getStake()
      amount = currencyManager.localize amount, false
      @addTickets(label, ticketX, amount)

    @

  # -------------------------------------------

  _setDimension: (viewportWidth, viewportHeight) ->
    @w = viewportWidth
    y = viewportHeight - @h
    @position.y = y

  # -------------------------------------------

  addBg: ->
    @bg = new PIXI.Graphics()
    @bg.beginFill(0x000000)
    @bg.drawRect(0,0,@w,@h)
    @bg.endFill()
    @bg.alpha = @bgAlpha
    @addChildAt(@bg,0)

  # -------------------------------------------

  addButtonContainer: ->
    @buttonContainer = new PIXI.Container()
    @addChild @buttonContainer

  # -------------------------------------------

  addLine: (x) ->
    x = x + 45
    graphics = new PIXI.Graphics()
    graphics.lineStyle(1, 0xffffff)
    graphics.moveTo(x, 0)
    graphics.lineTo(x, 45)
    graphics.endFill()
    graphics.alpha = 0.1
    graphics.cachedAsBitmap = true
    @buttonContainer.addChild(graphics)

  # -------------------------------------------

  addHomeButton: (x) ->
    log.info @constructor.name, 'addHomeButton'

    return if @homeButton?

    options =
      type: 'menu'
      tint: gameModel.primaryColor
      buttonImage: imageManager.makeTexturesFromName('btn-home-normal')[0]
      buttonHoverImage: imageManager.makeTexturesFromName('btn-home-hover')[0]

    @homeButton =  new BaseButton(options)
    @homeButton.tapped = (e) => @homeButtonClick(e)
    @homeButton.position.set(x,@buttonYOffset)
    @buttonContainer.addChild @homeButton
    @addLine(x)

  # -------------------------------------------

  homeButtonClick: (e) ->
    eventManager.trigger 'home'
    e.stopPropagation()

  # -------------------------------------------

  addHelpButton: (x) ->
    log.info @constructor.name, 'addHelpButton'

    return if @helpButton?

    options =
      type: 'menu'
      tint: gameModel.primaryColor
      buttonImage: imageManager.makeTexturesFromName('btn-help-normal')[0]
      buttonHoverImage: imageManager.makeTexturesFromName('btn-help-hover')[0]

    @helpButton =  new BaseButton(options)
    @helpButton.tapped = (e) => @helpButtonClick(e)
    @helpButton.position.set(x,@buttonYOffset)

    @buttonContainer.addChild @helpButton
    @addLine(x)

  # -------------------------------------------

  helpButtonClick: (e) ->

    eventManager.trigger 'show-help'
    e.stopPropagation()

  #----------------------------------------------

  addSettingsButton: (x) ->
    # log.info @constructor.name, 'addSettingsButton'

    return if @settingsButton?

    # Hack to always hide settings
    if false #gameModel.shouldShowRealityCheck()
      options =
        type: 'menu'
        tint: gameModel.primaryColor
        buttonImage: imageManager.makeTexturesFromName('btn-settings-normal')[0]
        buttonHoverImage: imageManager.makeTexturesFromName('btn-settings-hover')[0]
    else
      options =
        type: 'menu'
        tint: gameModel.primaryColor
        toggleBtn: true
        toggleState: !gameModel.getMute()
        buttonImage: imageManager.makeTexturesFromName('btn-soundon-normal')[0]
        buttonHoverImage: imageManager.makeTexturesFromName('btn-soundon-normal')[0]
        buttonOffImage: imageManager.makeTexturesFromName('btn-soundoff-normal')[0]
        buttonOffHoverImage: imageManager.makeTexturesFromName('btn-soundoff-normal')[0]


    @settingsButton =  new BaseButton(options)
    @settingsButton.position.set(x,@buttonYOffset)
    @buttonContainer.addChild @settingsButton

    # Hack to always hide settings

    @settingsButton.tapped = (e) =>
      if false #gameModel.shouldShowRealityCheck()
        @settingsButtonClick(e)
      else
        @toggleSoundClick(e)


    @addLine(x)

  # -------------------------------------------

  settingsButtonClick: (e) ->
    eventManager.trigger 'show-settings'
    e.stopPropagation()

  # -------------------------------------------

  toggleSoundClick: (e) ->
    e.stopPropagation()

    state = @settingsButton.toggleState()

    eventManager.trigger 'mute'

  # -------------------------------------------

  displaySoundOnButton: ->
    @settingsButton.setOn()

  # -------------------------------------------

  displaySoundOffButton: ->
    @settingsButton.setOff()

  # -------------------------------------------

  addInfoContainer: ->
    @infoContainer = new PIXI.Container()
    @addChild @infoContainer
    @infoContainer.x = gameModel.rendererWidth - @infoContainerXOffset

  # -------------------------------------------

  addTickets: (label,x, amount) ->
    amount = '' unless amount?

    y = @textYOffset

    @ticketLabel = new PIXI.Text label, @labelStyle unless @ticketLabel?
    @infoContainer.addChild @ticketLabel
    @ticketLabel.centerAtPoint(x,y)
    @ticketLabel.clarify()

    y = y + @textGap

    @ticketValue = new PIXI.Text "#{amount}", @valueStyle
    @infoContainer.addChild @ticketValue
    @ticketValue.centerAtPoint(x,y)
    @ticketValue.clarify()

  # -------------------------------------------

  addBalance: (amount, x) ->

    y = @textYOffset

    @balanceLabel = new PIXI.Text __t.str('Balance:').toUpperCase(), @labelStyle unless @balanceLabel?
    @infoContainer.addChild @balanceLabel
    @balanceLabel.centerAtPoint(x,y)
    @balanceLabel.clarify()

    y = y + @textGap

    @balanceValue = new PIXI.Text '', @valueStyle
    @infoContainer.addChild @balanceValue
    @balanceValue.centerAtPoint(x,y)
    @balanceValue.centerPoint = {x:x,y:y}
    @balanceValue.clarify()

    @setBalance amount

  # -------------------------------------------

  instantFinishBalance: ->
      # end current counter
      if @counterTween?
        @counterTween.totalProgress(1).kill();

  # -------------------------------------------

  updateBalance: (newBalance,cb) ->

    @instantFinishBalance()

    animate = true

    if typeof newBalance is 'object'
      animate = newBalance.animate
      newBalance = newBalance.balance

    # if this is a debit or we are getting initial balance
    if @currentBalance >= newBalance or @currentBalance < 0 or not animate
      @setBalance(newBalance)
      @centerBalance()
      return

    diff = newBalance - @currentBalance

    currencyMulitplier = gameModel.getCurrencyMultiplier()

    diff = Math.ceil(diff / currencyMulitplier)
    maxPrize = gameModel.getMaxPrize() / currencyMulitplier

    # max & min seconds
    min = 2
    max = 15 - min
    scale = max / Math.log10(maxPrize)
    timeLength = (Math.log(diff) * Math.LOG10E * scale) + min

    balance = @currentBalance

    obj =
      balance: @currentBalance

    to =
      ease: Power3.easeInOut
      balance: newBalance,
      onUpdate: =>
        @setBalance(obj.balance)
        # play sound here

      onComplete: =>
        @centerBalance()
        @counterTween = null
        # soundManager.play 'coin-done'
        cb() if cb?

    @counterTween = Tween.to(obj, timeLength, to)

  # -------------------------------------------

  setBalance: (amount) ->

    if gameModel.getDontShowBalance()
      return false

    if @currentBalance is amount
      return false

    @currentBalance = amount

    if not amount? or amount < 0
      amount = ''
    else
      amount = currencyManager.localize amount, false

    newLength = amount.length
    oldLength = @balanceValue.text.length

    @balanceValue.text = amount

    if newLength isnt oldLength
      @centerBalance()

    true

  # -------------------------------------------

  centerBalance: ->
      x = @balanceValue.centerPoint.x
      y = @balanceValue.centerPoint.y
      @balanceValue.centerAtPoint(x,y)

  # -------------------------------------------

  updateTicketCount: (amount) ->
    @ticketValue.text = "#{amount}"

  # -------------------------------------------

  showLastWin: (amount) ->

    amount = currencyManager.localize amount
    lastWin = new PIXI.Text amount, @lastWinStyle
    lastWin.alpha = 1
    x = @balanceValue.x + (@balanceValue.width/2)
    y = @balanceValue.y - 30
    lastWin.centerAtPoint(x,y)
    @infoContainer.addChild lastWin

    # to =
    #   y: @balanceValue.y
    #   alpha: 1
    #   onComplete: ->
    #     lastWin.removeSelf()

    # Tween.to(lastWin, 2, to)

  # -------------------------------------------

  resize: (rendererW, rendererH) ->
    @_setDimension(rendererW, rendererH)
    @removeChild(@bg)
    @bg = null
    @addBg()

    @infoContainer.x = rendererW - @infoContainerXOffset
    @infoContainer.bringToFront()

  # -------------------------------------------

module.exports = BottomBarView


// WEBPACK FOOTER //
// ./coffee/view/bottom-bar-view.coffee